const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "background.default",
        width: "100%",
    },
    innerBox: {
        width: "100%",
        textAlign: "left",
    },
    subheader: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: 1.5 /* 24px */,
        letterSpacing: "0.15px",
    },
    formControl: {
        width: "100%",
    },
    card: {
        width: "100%",
    },
    cardContent: {
        width: "100%",
        height: "auto",
    },
    footNoteText: {
        fontWeight: 400,
        fontSize: "12px",
        marginTop: "15px",
    },
    instructionText: {
        fontWeight: 400,
        fontSize: "12px",
    },
    statusRecord: {
        fontWeight: 500,
        fontSize: "14px",
    },
    footerBtnSection: {
        p: 1,
        display: "flex",
        justifyContent: "left",
        width: "100%",
        gap: "20px",
    },
    formControlSection: {
        mb: 2,
        width: "100%",
    },
    marginBottomBreak: {
        mb: 2,
    },
};

export default styles;
